import * as yup from "yup";

export const loginSchema = yup
    .object({
        username: yup
            .string()
            .required("Username è obbligatorio")
            .trim(),
        password: yup
            .string()
            .required("Password è obbligatoria")
            .trim()
    });

export const signupProducerSchemaNew = yup
    .object({
        email: yup
            .string()
            .email("Il formato della email non è corretto")
            .required("Email è obbligatoria"),
        password: yup
            .string()
            .required("Password è obbligatoria")
            .min(8, "Inserire almeno 8 caratteri")
            .matches(/[a-z]/, "Inserire almeno un carattere minuscolo")
            .matches(/[A-Z]/, "Inserire almeno un carattere maiuscolo")
            .matches(/[0-9]/, "Inserire almeno un numero")
            .matches(/[!@#$%^&*(),.?":{}|<>]/, "Inserire almeno un carattere speciale")
            .trim(),
    })

export const signupSchemaOne = yup
    .object({
        username: yup
            .string()
            .required("Username è obbligatorio")
            .trim(),
        email: yup
            .string()
            .email("Il formato della email non è corretto")
            .required("Email è obbligatoria"),
        password: yup
            .string()
            .required("Password è obbligatoria")
            .min(8, "Inserire almeno 8 caratteri")
            .matches(/[a-z]/, "Inserire almeno un carattere minuscolo")
            .matches(/[A-Z]/, "Inserire almeno un carattere maiuscolo")
            .matches(/[0-9]/, "Inserire almeno un numero")
            .matches(/[!@#$%^&*(),.?":{}|<>]/, "Inserire almeno un carattere speciale")
            .trim()
    });

export const signupProducerSchemaTwoNew = yup
    .object({
        name: yup
            .string()
            .required("Il nome è obbligatorio")
            .trim(),
        address: yup
            .string()
            .notRequired()
            .trim(),
        phone: yup
            .string()
            .notRequired()
            .test('is-number', 'Il numero può contenere solo cifre', value => {
                return !value || /^[0-9]+$/.test(value);
            })
            .trim(),
        contactEmail: yup
            .string()
            .email("Il formato della email non è corretto")
            .notRequired()
            .trim(),
        website: yup
            .string()
            .notRequired()
            .trim(),
        piva: yup
            .string()
            .notRequired()
            .nullable()
            .trim()
    });

export const signupSchemaTwo = yup
    .object({
        nome: yup
            .string()
            .required("Il nome è obbligatorio")
            .trim(),
        indirizzo: yup
            .string()
            .trim(),
        telefono: yup
            .string()
            .notRequired()
            .test('is-number', 'Il numero può contenere solo cifre', value => {
                return !value || /^[0-9]+$/.test(value);
            })
            .trim(),
        contact_email: yup
            .string()
            .email("Il formato della email non è corretto")
            .trim(),
        website: yup
            .string()
            .trim(),
        partita_iva: yup
            .string()
            .trim()
    });

export const signupProducerSchemaThreeNew = yup
    .object({
        description: yup
            .string()
            .trim()
    });

export const signupSchemaThree = yup
    .object({
        descrizione: yup
            .string()
            .trim()
    });
